interface IButtonDescriptor
{
		title: string | HTMLElement | JQuery;
		id?: string;
		behaviour?: string;
		style?: string;
		block?: boolean;
		size?: string;
		disabled?: boolean;
		on?: EventListenerList;
		classes?: string[];
		attr?: { [key: string] : string };
}

class Button
{
	private element: JQuery;

 	constructor( descriptor: IButtonDescriptor )
 	{
		this.element = $( document.createElement( 'button' ) );

		this.element.append( descriptor.title );

		if ( descriptor.id )
		{
			this.element.attr( 'id', descriptor.id );
		}

		this.element.attr( 'type', 'button' );
		if ( descriptor.behaviour )
		{
			this.element.attr( 'type', descriptor.behaviour );
		}

		this.element.addClass( 'btn' );

		if ( descriptor.style )
		{
			this.element.addClass( 'btn-' + descriptor.style );
		}
		else
		{
			this.element.addClass( 'btn-default' );
		}

		if ( descriptor.size )
		{
			this.element.addClass( 'btn-' + descriptor.size );
		}

		if ( descriptor.block )
		{
			this.element.addClass( 'btn-block' );
		}

		if ( descriptor.disabled )
		{
			this.element.attr( 'disabled', 'disabled' );
		}

		if ( descriptor.on )
		{
			appendEventListener( this.element, descriptor.on );
		}

		if ( descriptor.attr )
		{
			for ( const i in descriptor.attr )
			{
				if ( descriptor.attr[ i ] !== undefined )
				{
					this.element.attr( i, descriptor.attr[ i ] );
				}
			}
		}

		if ( descriptor.classes )
		{
			for ( const i in descriptor.classes )
			{
				if ( descriptor.classes[ i ] !== undefined )
				{
					this.element.addClass( descriptor.classes[ i ] );
				}
			}
		}
	}

 	public getElement() : HTMLElement
	{
		return this.element[ 0 ];
	}

}
